<!--<div>Location card is loaded</div>-->
@if (isDesktop) {
  <!-- Desktop map code -->
  <div>
    @if (compData?.container?.title) {
      <div class="loc">
        {{ compData?.container?.title | titlecase }}
      </div>
    }
    <div>
      @if (showMap) {
        <div>
          <app-detail-page-ola-map
            [containerName]="'d-bdp-omap'"
            [center]="center"
            [mapConfig]="{
              mainProperty: compData?.container,
              otherProperties: [],
              overrideData: false
            }"
          ></app-detail-page-ola-map>
        </div>
      } @else {
        <div (click)="onShowMap()" class="mapPlaceholder">
          <img
            ngSrc="https://static-img.bag2bag.in/new-assets/india/new-app/banners/map-placeholder_v2.png?format=webp&quality=10&height=400px"
            alt="map-placeholder" width="100" height="100"
            loading="lazy">
          <div class="vwBtn">
            <div class="vwFlx flex-container ion-align-items-center" tapEffect>
              <div class="title">Click to View Map</div>
              <div class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                     stroke="currentColor" class="size-4">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                  <path stroke-linecap="round" stroke-linejoin="round"
                        d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    <!--<div>
      <div>Locations</div>
    </div>-->

  </div>
} @else {
  <!-- mobile map code -->
  <div class="mobCard">
    @if (compData?.container?.title) {
      <div class="loc">
        {{ compData?.container?.title | titlecase }}
      </div>
    }
    @if (compData?.container?.description) {
      <div class="add">
        {{ compData?.container?.description | toParagraph }}
      </div>
    }
    <div>
      <div class="pcImg" (click)="openMapModal()">
        <div class="mapPlaceholder">
          <img
            ngSrc="https://static-img.bag2bag.in/new-assets/india/new-app/banners/map-placeholder_v2.png?format=webp&quality=10&height=200px"
            alt="map-placeholder" width="100" height="100">
          <div class="vwBtn">
            <div class="vwFlx flex-container ion-align-items-center">
              <div class="title">Click to View Map</div>
              <div class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                     stroke="currentColor" class="size-4">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                  <path stroke-linecap="round" stroke-linejoin="round"
                        d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--<div>
        Nearby Locations
      </div>
      <div>
        View All
      </div>-->
    </div>
  </div>
}


@if (!isServer) {
  <ion-modal
    #mapModal
    class="location-modal"
    [initialBreakpoint]="1"
    [breakpoints]="[0, 1]"
  >
    <ng-template>
      <div class="header">
        <div class="title">{{ compData?.container?.displayName | titlecase }}</div>
        <div class="close-icon" (click)="dismissMapModal()" tapEffect>
          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20"
               viewBox="0 0 24 24">
            <path fill="#3a3a3a"
                  d="M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z"></path>
          </svg>
        </div>
      </div>
      <ion-content [scrollY]="false">
        <div class="coupon-lst-wrap">
          <app-detail-page-ola-map
            [containerName]="'m-bdp-omap'"
            [center]="center"
            [mapConfig]="{
              mainProperty: compData?.container,
              otherProperties: [],
              overrideData: false
            }"
          ></app-detail-page-ola-map>
        </div>
      </ion-content>
    </ng-template>
  </ion-modal>
}

<!--<ng-template #mapContentTemplate>
  <div class="loc-wrap">
    @if (exploreLocations?.length > 0) {
      <div class="lnd-mrk-wrap">
        @for (location of exploreLocations; track location) {
          <div>
            <div class="loc-inner-wrap">
              <div class="title">
                {{ location?.title }}
              </div>
              <div class="loc-dta">
                @for (item of location?.data; track item) {
                  <div class="dta-wrap">
                    <div class="dta-flx">
                      <div class="title">
                        {{ item?.title }}
                      </div>
                      <div class="desc">
                        {{ item?.description }}
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
</ng-template>-->
